import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule } from '@angular/common/http';
import { SignaturePadModule } from 'angular2-signaturepad';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClientComponent } from './client/client.component';
import { AdminComponent } from './admin/admin.component';
import { StartComponent } from './client/start/start.component';
import { PatientInfoComponent } from './client/patient-info/patient-info.component';
import { AppEnum } from 'src/providers/app.enum';
import { ReactiveFormsModule } from '@angular/forms';
import { SigninLogComponent } from './admin/signin-log/signin-log.component';
import { LoginComponent } from './client/login/login.component';
import { SigninComponent } from './admin/signin/signin.component';
import { PatientTypeComponent } from './client/patient-type/patient-type.component';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    AppComponent,
    ClientComponent,
    AdminComponent,
    StartComponent,
    PatientInfoComponent,
    LoginComponent,
    SigninLogComponent,
    SigninComponent,
    PatientTypeComponent
  ],
  imports: [
    HttpClientModule,
    SignaturePadModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    RecaptchaModule,

  ],
  providers: [AppEnum],
  bootstrap: [AppComponent]
})
export class AppModule { }
